import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import * as FollowPredictionActions from '../actions/follow-prediction.actions';
import { FollowPredictionService } from '../../services/follow-prediction.service';
import { MessageService } from 'primeng/api';
import * as PredictionActions from '../actions/prediction.actions';

@Injectable({ providedIn: 'root' })
export class FollowPredictionEffects {
    private followPredictionService = inject(FollowPredictionService);
    private actions$ = inject(Actions);
    private messageService = inject(MessageService);
    followPrediction$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FollowPredictionActions.followPrediction),
            switchMap(action =>
                this.followPredictionService.followPrediction(action).pipe(
                    tap(response => {
                    }),
                    map((predict) => FollowPredictionActions.followPredictionSuccess({ predictionId: predict.predictionId, userId: predict.userId, id: predict.id })),
                    catchError(error => {
                        const message =
                            error.status === 404 && error.error?.error
                                ? error.error.error
                                : 'Une erreur est survenue, essayer plus tard';
                        return of(FollowPredictionActions.followPredictionFailure({ error : message }))
                    })
                )
            )
        )
    );

    followPredictionSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FollowPredictionActions.followPredictionSuccess),
            tap(action => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Prédiction suivie avec succès !',
                    life: 3000
                });

            })
        ),
        { dispatch: false }
    );
    followPredictionFailure$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FollowPredictionActions.followPredictionFailure),
            tap(action => {
                console.error(`Failed to follow prediction: ${action.error}`);
            })
        ),
        { dispatch: false }
    );

    unfollowPrediction$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FollowPredictionActions.unfollowPrediction),
            switchMap(action =>
                this.followPredictionService.unfollowPrediction(action).pipe(
                    map((res) => FollowPredictionActions.unfollowPredictionSuccess({ predictionId: res.prediction_id, userId: res.user_id })),
                    catchError(error => of(FollowPredictionActions.unfollowPredictionFailure({ error })))
                )
            )
        )
    );

    unfollowPredictionSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FollowPredictionActions.unfollowPredictionSuccess),
            tap(({ userId }) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'prédiction désabonnée avec succès !',
                    life: 3000
                });
            }),
            map(({ userId }) => PredictionActions.loadUserPredictions({ userId }))
        )
    );
    loadFollowedPredictions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FollowPredictionActions.loadFollowedPredictions),
            switchMap(action =>
                this.followPredictionService.getFollowedPredictions(action.userId).pipe(
                    map(predictions => FollowPredictionActions.loadFollowedPredictionsSuccess({ predictions })),
                    catchError(error => of(FollowPredictionActions.loadFollowedPredictionsFailure({ error })))
                )
            )
        )
    );
    loadFollowedPredictionsSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FollowPredictionActions.loadFollowedPredictionsSuccess),
            tap(action => {
            })
        ),
        { dispatch: false }
    );
    loadFollowedPredictionsFailure$ = createEffect(() =>
        this.actions$.pipe(
            ofType(FollowPredictionActions.loadFollowedPredictionsFailure),
            tap(action => {
            })
        ),
        { dispatch: false }
    );


}